import { render } from "./PineappleRulesPage.vue?vue&type=template&id=dffe5d4e&ts=true"
import script from "./PineappleRulesPage.vue?vue&type=script&lang=ts"
export * from "./PineappleRulesPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__